import { Component } from '@angular/core';

@Component({
  selector: 'what-we-do-research',
  templateUrl: './research.component.html',
  styleUrls: ['./research.component.css'],
})
export class ResearchComponent {}
